<template>
  <auth-layout>
    <div class="mb-6">
      <h2 class="xl:text-4xl xl:font-light text-2xl font-bold">
        Coming Soon
      </h2>
    </div>

    <div
      class="text-primary-900 mb-4 border border-primary-200 bg-primary-100 rounded p-4 flex flex-col"
    >
      <svg
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 24 24"
        class="w-24 h-24 self-center block icons-primary mr-3"
      >
        <g id="icon-important-4">
          <path
            d="M12 2a10 10 0 1 1 0 20 10 10 0 0 1 0-20z"
            class="primary"
          ></path>
          <path
            d="M12 18a1.5 1.5 0 1 1 0-3 1.5 1.5 0 0 1 0 3zm1-5.9c-.13 1.2-1.88 1.2-2 0l-.5-5a1 1 0 0 1 1-1.1h1a1 1 0 0 1 1 1.1l-.5 5z"
            class="secondary"
          ></path>
        </g>
      </svg>
      <div class="w-full mt-2 text-center text-sm">
        <p>
          This site will be open for ARMD applications at 5pm on Monday 6th
          July.
        </p>
      </div>
    </div>
  </auth-layout>
</template>

<script>
export default {
  name: "ComingSoon",
  data() {
    return {
      //
    };
  },
  created() {
    document.title = `Coming Soon :: ${document.title}`;
  },
  methods: {
    //
  }
};
</script>

<style></style>
